export default {
  latestTransferPortalActivity: "Latest Activity"
};
